import React from 'react';
import { ShieldCheckIcon, ExternalLinkIcon } from 'lucide-react';
export function GuidelinesLink() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-391">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-392">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-393">
          <ShieldCheckIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-394" />
          <div className="flex-1" data-id="element-395">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-396">
              What do you need?
            </p>
            <a href="https://www.fentonlakes.com/BowlingPinShootRules" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-397">
              Click here to read the guidelines and rules.
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-398" />
        </div>
      </div>
    </div>;
}